import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngxs/store";
import {TabsAction} from "../../../store/actions/tabs.action";
import {FormAction} from "../../../store/actions/form.action";
import {GlobalService, HeaderState} from "../../../core/services/global.service";
import {
  PagetitleService, SpinningWheelPreviewToggle,
  SpinningWheelSetting,
  SpinningWheelSettingToggle
} from "../../../core/services/pagetitle.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() isBackgroundWhite: boolean = false
  @Input() pageTitle = 'Settings';
  @Input() showBackArrow: boolean = false
  @Input() setting: boolean = false
  @Input() previousUrl = '/tabs/dashboard'
  @Input() isCampaign: boolean = false
  @Input() isTemplateFolder: boolean = false
  @Input() type: string = ''
  @Input() origin: string = ''
  @Input() showPrint: boolean = false;
  @Output() print = new EventEmitter<null>();
  isSpinningWheelSetting: boolean = false
  isSpinningWheelPreview: boolean = false
  HideHeader : boolean = false

  constructor(
    private _location: Location,
    private _router: Router,
    private store: Store,
    private globalService: GlobalService,
    private _titleService: PagetitleService,
    private _settingService: SpinningWheelSetting,
    private _service: SpinningWheelSettingToggle,
    private _previewToggle: SpinningWheelPreviewToggle,
    private _headerState : HeaderState,
    private _translate : TranslateService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['previousUrl']) {
      this.previousUrl = changes['previousUrl'].currentValue
    }
    if (changes['origin']) {
      this.origin = changes['origin'].currentValue
    }
    if (changes['type']) {
      this.type = changes['type'].currentValue
    }
  }

  ngOnInit() {
    this._titleService.$title.subscribe({
      next: (res) => {
        this.pageTitle = res
      }
    })

    this._settingService.$setting.subscribe({
      next: (res) => {
        this.isSpinningWheelSetting = res
      }
    })

    this._previewToggle.$preview.subscribe({
      next: (res) => {
        this.isSpinningWheelPreview = res
      }
    })

    this._headerState.$header.subscribe({
      next:(res) => {
        this.HideHeader = res
      }
    })
  }

  onBack() {
    this.globalService.setData('customData', {checkConfirmation: 'true'});
    this.store.dispatch(new FormAction.ClearFormValue())

    if(this.isSpinningWheelPreview) {
      this.isSpinningWheelPreview = false
      this._headerState.setHeader(true)
      this._previewToggle.togglePreview(false)
      this._titleService.setPageTitle(this._translate.instant('_spinning_wheel_setting_title_'));
      return;
    }

    if (this.isSpinningWheelSetting) {
      this.isSpinningWheelSetting = false
      this._service.toggleSettingPage(false)
      this._titleService.setPageTitle(this._translate.instant('_new_post_'));
      return;
    }

    if (this.isCampaign) {

      this.store.dispatch(new TabsAction.ClearTabState());
    }
    if (this.isTemplateFolder) {
      this._location.back()
    } else if (this.isCampaign && this.origin === 'calender') {

      this._router.navigate(['/tabs/home'], {replaceUrl: true}).then()
    } else if (this.origin === 'campaign') {
      this._router.navigate([this.previousUrl], {replaceUrl: true, queryParams: {type: this.type}}).then()
    } else if (this.origin == 'edit') {
      this._router.navigate([this.previousUrl], {replaceUrl: true, queryParams: {type: this.type}}).then()
    } else {
      this._router.navigate([this.previousUrl], {replaceUrl: true}).then()
    }
  }

  onPrint() {
    this.print.emit();
  }

}
